import classes from '../Networks.module.scss';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      'tunnels.tunnelType': filter['tunnels.tunnelType'][0]
        ? filter['tunnels.tunnelType']
        : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      country: filter.country[0] ? filter.country : '*',
      regionName: filter.regionName[0] ? filter.regionName : '*',
      regionCountry: filter.regionCountry[0] ? filter.regionCountry : '*',
      plan: filter.plan[0] ? filter.plan : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      status: filter.status[0] ? filter.status : '*',
      networkVersion: filter.networkVersion[0] ? filter.networkVersion : '*',
      providerRegionName: filter.providerRegionName[0]
        ? filter.providerRegionName
        : '*',
      provider: filter.provider[0] ? filter.provider : '*',
      gatewayImageType: filter.gatewayImageType[0]
        ? filter.gatewayImageType
        : '*',
      gatewayImageVersion: filter.gatewayImageVersion[0]
        ? filter.gatewayImageVersion
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};

export const statusStyle = status => {
  switch (status) {
    case 'active': {
      return classes.statusGreen;
    }
    case 'inactive': {
      return classes.statusRed;
    }
    default: {
      return classes.statusGrey;
    }
  }
};
